import { getAskAiAdminPath } from '@lumapps/ask-ai/utils';
import { Route, AppId, createEntityManagementRoutes } from '@lumapps/router';

import type { AskAiSource } from './types';

const { baseRoute, createRoute, editRoute, getEditRoute } = createEntityManagementRoutes({
    slug: getAskAiAdminPath('sources'),
    id: 'ai-search-sources',
    appId: AppId.backOffice,
});

export const askAiEditSource = (sourceId: AskAiSource['id']): Route => getEditRoute(sourceId);

export {
    baseRoute as askAiBaseSourcesAdminRoute,
    editRoute as askAiEditSourceRoute,
    createRoute as askAiCreateSourceRoute,
};

/** Parameters for the Ask Ai source form page (edition) */
export interface AskAiSourceFormParams {
    id: string;
}
